import styled from 'styled-components';

const ButtonProgressContainer = styled.div`
  position: relative;
  width: ${({ fullWidth }: { fullWidth?: boolean }): string | undefined =>
    fullWidth ? '100%' : undefined};
`;

export default ButtonProgressContainer;
